'use client';

import { c as _c } from "react/compiler-runtime";
import { VaultHeroLoading } from '../../VaultV1/VaultHero/states';
import { VaultV2HeroLoading } from '../../VaultV2/VaultV2Hero/states';
import { useVaultRoute } from './VaultRouteContext';

/** The page's hero fallback, with the resolved vault's name and description. */
const VaultRouteHeroLoading = () => {
  const $ = _c(4);
  const route = useVaultRoute();
  const Hero = route?.isVaultV2 === false ? VaultHeroLoading : VaultV2HeroLoading;
  const t0 = route?.name;
  const t1 = route?.description;
  let t2;
  if ($[0] !== Hero || $[1] !== t0 || $[2] !== t1) {
    t2 = <Hero name={t0} description={t1} />;
    $[0] = Hero;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default VaultRouteHeroLoading;